
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiThreewayAcuatorPistonInleftLeft100 as ObiThreewayAcuatorPistonInleftLeft100Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-threeway-acuator-piston-inleft-left-100.js';
 
 
 

 
 export const ObiThreewayAcuatorPistonInleftLeft100 = createComponent({
   react: React,
   tagName: 'obi-threeway-acuator-piston-inleft-left-100',
   elementClass: ObiThreewayAcuatorPistonInleftLeft100Element,
   events: {
     
   }
  });
 
 